import { memo } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/icons/icon-24-logo-enhancor-large.tsx
/**
* icon.24.logo.enhancor.large
*
* ![](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IiMwMDAiIHJ4PSI0Ii8+PHBhdGggZmlsbD0iI2ZmZiIgZD0iTTE0LjI3NSAzYy44MjggMCAxLjYzLjExNCAyLjM5MS4zMjNhOS4zMSA5LjMxIDAgMCAwLTUuOTMgOC42NzNjMCAzLjk0OSAyLjQ2IDcuMzIgNS45MyA4LjY3M0E4Ljk5NyA4Ljk5NyAwIDEgMSAxNC4yNzYgM20yLjUzNiA3LjA4NGExLjkxMiAxLjkxMiAwIDEgMS0uMDAxIDMuODIzIDEuOTEyIDEuOTEyIDAgMCAxIDAtMy44MjMiLz48L3N2Zz4=)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=26838-11089
*/
const Icon24LogoEnhancorLarge = memo(function Icon24LogoEnhancorLarge(props) {
	return /* @__PURE__ */ jsx("svg", {
		width: "24",
		height: "24",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		"data-fpl-icon-size": "24L",
		children: /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			d: "M14.275 3c.828 0 1.63.114 2.391.323a9.31 9.31 0 0 0-5.93 8.673c0 3.949 2.46 7.32 5.93 8.673A8.997 8.997 0 1 1 14.276 3m2.536 7.084a1.912 1.912 0 1 1-.001 3.823 1.912 1.912 0 0 1 0-3.823"
		})
	});
});
//#endregion
export { Icon24LogoEnhancorLarge };

//# sourceMappingURL=icon-24-logo-enhancor-large.js.map